import InputGroupForm from '@/components/InputGroupForm.vue'
import sportKind from "@/views/SportKind.vue";
import discipline from "@/views/totalspr/totalSpr";
import FormSelectVue from "@/components/resultTeam/FormSelectVue.vue";
import DisciplineDataService from '@/utils/services/disciplineService'
import SportsmanService from '@/utils/services/sportsmanService'

export default {
  computed: {
    discipline() {
      return discipline
    },
    sportKind() {
      return sportKind
    }
  },
  components: {FormSelectVue, InputGroupForm},
  props: {
    schoolList: {
      type: Array,
      default: () => []
    },
    localityList: {
      type: Array,
      default: () => []
    },
    rankList: {
      type: Array,
      default: () => []
    },
    ageKindList: {
      type: Array,
      default: () => []
    },
    stageTrainingList: {
      type: Array,
      default: () => []
    },
    teamList: {
      type: Array,
      default: () => []
    },
    bestEventList: {
      type: Array,
      default: () => []
    },
    secondLocalityList: {
      type: Array,
      default: () => []
    },
    peoplePostList: {
      type: Array,
      default: () => []
    },
    structureTeamList: {
      type: Array,
      default: () => []
    },
    federationList: {
      type: Array,
      default: () => []
    },
    filterObject: {
      type: Object,
      default: {
        schoolId: null,
        isTeamFlg: null,
        federationId: null,
        isTrainer: null,
        trainer_id: null,
        dat1: null,
        dat2: null
      }
    }
  },
  data() {
    return {
      isTrueFalseOptions: [
        {value: false, text: 'Нет'},
        {value: true, text: 'Да'}
      ],
      genderOptions: [
        {value: 'MAN', text: 'Мужчины'},
        {value: 'WOMAN', text: 'Женщины'}
      ],
      disciplineList: [],
      trainerList: [],
      filterValue: {
        structureId: null,
        schoolId: null,
        isTeamFlg: null,
        federationId: null,
        localityId: null,
        isTrainer: null,
        dat1: null,
        dat2: null,
        gender: null,
        rankId: null,
        ageKindId: null,
        peoplePostId: null,
        address: null,
        disciplineId: null,
        stageTrainingId: null,
        teamId: null,
        trainerId: null,
        secondLocalityId: null,
        bestEventId: null
      },
      isShowFilter: false
    }
  },
  watch: {
    'filterValue.federationId': function (val) {
      if (val === null || val === undefined) {
        this.disciplineList = []
        this.trainerList = []
      } else {
        this.loadDisciplines(val)
        this.loadTrainersAll(val)
      }
    }
  },
  methods: {
    applyFilter() {
      this.$emit('input', this.filterValue)
      this.$emit('applyFilter', this.filterValue)
      this.isShowFilter = !this.isShowFilter
    },
    clearFilter() {
      for (var key in this.filterValue) {
        if (typeof this.filterValue[key] == 'string') {
          this.filterValue[key] = null
        } else if (typeof this.filterValue[key] == 'array') {
          this.filterValue[key] = []
        } else {
          this.filterValue[key] = null
        }
      }
      this.applyFilter()
    },
    checkDate1() {
      if (this.filterValue.dat1 > this.filterValue.dat2) {
        this.filterValue.dat2 = this.filterValue.dat1
      }
    },
    showFilterDialog() {
      for (let key in this.filterObject) {
        this.filterValue[key] = this.filterObject[key];
      }
      this.isShowFilter = !this.isShowFilter
    },
    loadDisciplines(fedId) {
      this.disciplineList = [];
      var vm = this;
      DisciplineDataService.getDisciplineListByFederation(fedId)
      .then((response) => {
        vm.disciplineList = response.data
      })
      .catch((error) => console.log(error.message));
    },
    loadTrainersAll(federationId) {
      var vm = this;
      vm.trainerList = []
      SportsmanService.getSportsmanTrainers(federationId)
      .then((response) => {
        vm.trainerList = response.data;
      })
      .catch((error) => console.log(error.message));
    },
  }
}
